import './Header.css';
import HowToPlayScreen from '../../screens/HowToPlayScreen';
import { useEffect, useState } from 'react';

const Header = ({
  score = 0,
  time = 59,
  onPause = undefined,
  isPaused = false
}) => {
  const [isWarning, setIsWarning] = useState(false);

  useEffect(() => {
    setIsWarning(time <= 10);
  }, [time]);

  return (
    <>
      {!isPaused ? (
        <div
          className='header-game-container'
          style={{
            position: 'fixed',
            top: '-20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            pointerEvents: 'auto',
            visibility: 'visible',
            opacity: 1
          }}
        >
          <h1
            className='text-gold header-game-text'
            style={{
              width: '100%',
              textAlign: 'left'
            }}
          >
            {score}
          </h1>
          <h1
            className={`text-gold header-game-text ${isWarning ? 'timer-warning' : ''}`}
            style={{
              width: '100%',
              textAlign: 'center'
            }}
          >
            :{time}
          </h1>
          <h1 className='header-game-text'>
            <button
              className='header-game-help-icon'
              onClick={onPause}
              aria-label={isPaused ? 'Resume game' : 'Pause game'}
              type='button'
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                width: '100%',
                textAlign: 'right',
                pointerEvents: 'auto'
              }}
            >
              <img
                src='/assets/game/game-help.png'
                alt={isPaused ? 'Resume' : 'Pause'}
                width='40'
              />
            </button>
          </h1>
        </div>
      ) : (
        <HowToPlayScreen isPaused={isPaused} onPause={onPause} />
      )}
    </>
  );
};

export default Header;
